/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CanSendEmailResponse
 */
export interface CanSendEmailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CanSendEmailResponse
     */
    canSendEmail: boolean;
}

/**
 * Check if a given object implements the CanSendEmailResponse interface.
 */
export function instanceOfCanSendEmailResponse(value: object): value is CanSendEmailResponse {
    if (!('canSendEmail' in value) || value['canSendEmail'] === undefined) return false;
    return true;
}

export function CanSendEmailResponseFromJSON(json: any): CanSendEmailResponse {
    return CanSendEmailResponseFromJSONTyped(json, false);
}

export function CanSendEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CanSendEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'canSendEmail': json['can_send_email'],
    };
}

export function CanSendEmailResponseToJSON(json: any): CanSendEmailResponse {
    return CanSendEmailResponseToJSONTyped(json, false);
}

export function CanSendEmailResponseToJSONTyped(value?: CanSendEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'can_send_email': value['canSendEmail'],
    };
}

